module.exports = __webpack_public_path__ + "media/images/webpage/hotels/9494/plan2-2-bd5133d3c79e36058622806878e639ab.webp";